import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";

function TagInSearch(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <div className={`pointer padd5 ${props.selected?"selected bg-pc1":""}`} onClick={()=>{ props.selectMe(); }}>
      {props.visible.map((item, index)=>{
        if(!index) {
          return (
            <div key={item} className={`fs14 ${props.selected?"w1":"b1"}`}>{props.item[item]}</div>
          )
        } else {
          return <div key={item} className={`fs12  ${props.selected?"w1-op50":"w5"}`}>{props.item[item]}</div>
        }

      })}
    </div>
  )
};

TagInSearch.defaultProps = {};

TagInSearch.propTypes = {}

export default observer(TagInSearch);
